export default __webpack_public_path__ + "static/media/brgy_seal.7491e2f3.png";